import { pharmacyTechnicianUpsertModalRouteStore } from '../domain/upsert-modal-store';

export default (showing = true) => {
  pharmacyTechnicianUpsertModalRouteStore.setValue('showingDeleteConfirmationModal', showing);
};
